import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';

export const attendanceSteps = () => {
  const roleId = Number(decryptData(Cookies.get('role_id')));
  return [
    {
      target: '[data-tour="attendance-module"]',
      title: '🕒 Welcome to the Attendance Module',
      content:
        'This module helps you manage attendance records and review attendance-related information.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="daily-logs-tab"]',
      title: '📅 Daily Logs',
      content: 'View your daily attendance records and activity logs.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="historical-logs-tab"]',
      title: '🗂 Historical Logs',
      content: 'Review your attendance history and past records.',
      disableBeacon: true,
    },
    ...(roleId === 1 || roleId === 2
      ? [
          {
            target: '[data-tour="attendance-approval-tab"]',
            title: '✅ Attendance Approval',
            content: 'Review and approve employee attendance requests.',
            disableBeacon: true,
          },
          {
            target: '[data-tour="employee-history-tab"]',
            title: '👥 Employee Historical Logs',
            content: 'View attendance history and records for employees.',
            disableBeacon: true,
          },
        ]
      : []),
  ];
};
